/**
 * @generated SignedSource<<e39871a7de45949ac8dbc0aaffb2e7ad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerItemTileCarousel_item$data = {
  readonly serviceId: string | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentType": "PdpRespSellerItemTileCarousel_item";
};
export type PdpRespSellerItemTileCarousel_item$key = {
  readonly " $data"?: PdpRespSellerItemTileCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerItemTileCarousel_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItemTileCarousel_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "000b3f69e1e553ac4246fc39e2322dcb";

export default node;
